import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { pageResetMiddleWare, zodOptionalDateRange, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const labMasterTradesRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/trades/master_trades',
  validateSearch: z.object({
    tab: z.enum(['ongoing', 'upcoming', 'over', 'all']).default('all'),
    page: zodPage,
    dateRange: zodOptionalDateRange,
    query: z.string().optional(),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/lab/Trades/LabMasterTrades/LabMasterTradesPage/LabMasterTradesPage').then(
    (d) => d.Route
  )
);
